export interface RhythmClock {
  now(): number;
}

export function readRhythmClock(clock: RhythmClock): number {
  const value = clock.now();

  if (!Number.isFinite(value) || value < 0) {
    throw new RangeError("Rhythm clock must return a finite non-negative time");
  }

  return value;
}
